import { useEffect } from 'react';

/**
 * Hook to set document title
 * @param title - The page title
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}

